// src/KeyAnalytics/DateRangePickerComponent.jsx

import * as React from 'react';
import { Box, TextField, Button } from '@mui/material';
import { DateRangePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

export default function DateRangePickerComponent({ dateRange, setDateRange, onApply, onReset }) {
  // Local Dayjs state
  const [localRange, setLocalRange] = React.useState([
    dateRange[0] ? dayjs(dateRange[0], 'MM/DD/YYYY') : null,
    dateRange[1] ? dayjs(dateRange[1], 'MM/DD/YYYY') : null,
  ]);

  // Sync incoming string dates into Dayjs objects
  React.useEffect(() => {
    setLocalRange([
      dateRange[0] ? dayjs(dateRange[0], 'MM/DD/YYYY') : null,
      dateRange[1] ? dayjs(dateRange[1], 'MM/DD/YYYY') : null,
    ]);
  }, [dateRange]);

  // Called when Apply is clicked
  const handleApplyClick = () => {
    const [start, end] = localRange;
    onApply({
      from_date: start?.isValid() ? start.format('MM/DD/YYYY') : null,
      to_date: end?.isValid() ? end.format('MM/DD/YYYY') : null,
    });
  };

  // Called when Reset is clicked
  const handleResetClick = () => {
    setLocalRange([null, null]);
    onReset();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePicker
        startText="From"
        endText="To"
        value={localRange}
        onChange={(newVal) => setLocalRange(newVal)}
        renderInput={(startProps, endProps) => (
          <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
            <TextField {...startProps} size="small" />
            <TextField {...endProps} size="small" />
          </Box>
        )}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
        <Button size="small" onClick={handleResetClick}>
          Reset
        </Button>
        <Button size="small" variant="contained" onClick={handleApplyClick}>
          Apply
        </Button>
      </Box>
    </LocalizationProvider>
  );
}
